import { AudioManager } from '../core/AudioManager';
import { WalkAudio } from '../character/states/audio/WalkAudio';
import { RunAudio } from '../character/states/audio/RunAudio';
import { PistolShootAudio } from '../character/states/audio/PistolShootAudio';
import { RifleShootAudio } from '../character/states/audio/RifleShootAudio';
import { PoliceSirenAudio } from '../vehicles/audio/PoliceSirenAudio';
import { HurtCarAudio } from '../character/states/audio/HurtCarAudio';
import { PanicAudio } from '../character/states/audio/PanicAudio';
import { MotorAudio } from '../vehicles/audio/MotorAudio';
import { SkidAudio } from '../vehicles/audio/SkidAudio';
import { AmbientAudio } from './audio/AmbientAudio';
import { CarImpactAudio } from '../vehicles/audio/CarImpactAudio';

export function registerAllAudio(audioManager: AudioManager): void {
    audioManager.registerPreload(...WalkAudio.PRELOAD);
    audioManager.registerPreload(...RunAudio.PRELOAD);
    audioManager.registerPreload(...PistolShootAudio.PRELOAD);
    audioManager.registerPreload(...RifleShootAudio.PRELOAD);
    audioManager.registerPreload(...PoliceSirenAudio.PRELOAD);
    audioManager.registerPreload(...HurtCarAudio.PRELOAD);
    audioManager.registerPreload(...PanicAudio.PRELOAD);
    audioManager.registerPreload(...MotorAudio.PRELOAD);
    audioManager.registerPreload(...SkidAudio.PRELOAD);
    audioManager.registerPreload(...AmbientAudio.PRELOAD);
    audioManager.registerPreload(...CarImpactAudio.PRELOAD);
}
